export const commaCheck = (data) => {
  if (!data) { return ''; }
  if (data >= 1000) {
    return data
      .toString()
      .split('.')[0]
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  if (data.toString().match(/\./)) {
    return data.toString().split('.')[0];
  }

  return data;
};

export const getDecimals = (data) => {
  if (!data) { return ''; }
  return data.toFixed(2).toString().split('.')[1];
};

export const getDepositFormatted = (data) => {
  if (!data) { return ''; }
  return `$${data.toFixed(0)}`;
};

export const getPricingForClosestStore = ({
  experienceStore,
  rentalStores,
  rentalPricingData,
}) => {
  let pricingData;
  let closestPricingData;
  let closestStoreInfo;

  if (rentalPricingData && rentalStores && experienceStore) {
    pricingData = rentalPricingData.find(
      (store) => store.storeId.toString() === experienceStore.storeId.toString().padStart(4, '0'));
    if (!pricingData) {
      rentalStores.sort((store1, store2) => store1.distance - store2.distance);
      // loops through the store list to find the first store with pricing information.
      const closestStoreWithPricing = rentalStores.find((store) => {
        return rentalPricingData.find((pricing) => {
          return store.storeId === pricing.storeId;
        });
      });
      pricingData = rentalPricingData.find((pricing) => (
        closestStoreWithPricing.storeId === pricing.storeId
      ));
      closestStoreInfo = { storeName: closestStoreWithPricing.name, ...closestStoreWithPricing };
    } else {
      closestStoreInfo = experienceStore;
    }

    closestPricingData = pricingData;
  }

  return {
    closestPricingData,
    closestStoreInfo
  };
};
